// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider_slider__qGi48","inputGroup":"slider_inputGroup__M4HP8","range":"slider_range__YBV2R"};